import { getIsAuthenticated } from '@vrw/data/src/redux/auth/selectors'
import React, { useEffect } from 'react'
import { PathRouteProps, useLocation } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from '../../redux/hooks/hooks'
import { PATHS } from '../../router/paths'
import { useRedNavigate } from 'web/src/dataImplementation/useRedNavigate'
import { usePreviousDefault } from '@/hooks/usePrevious'

const DEFERRED_PATHS = [`account/promo-codes`]

const isDeferredPath = (pathname: string) => DEFERRED_PATHS.some((p) => pathname.indexOf(p) > -1)
const searchToParams = (search: string) => {
  const params = new URLSearchParams(search)
  return Object.fromEntries(params.entries())
}

/**
 * By default should the user not be auth'ed it will redirect to the home page.
 *
 * This can be change to enforce auth and take the user to the requested path
 *
 */
export const PrivateRoute = ({ children }: PathRouteProps) => {
  const dispatch = useAppDispatch()
  const isAuthenticated = useAppSelector(getIsAuthenticated)
  const { pathname, search } = useLocation()
  const navigate = useRedNavigate()
  const previousPathname = usePreviousDefault(pathname, '/')

  useEffect(() => {
    if (!isAuthenticated) {
      if (isDeferredPath(pathname)) {
        dispatch({
          type: 'CACHE_DEEPLINK',
          payload: { route: pathname, params: searchToParams(search) },
        })
      }
      navigate(PATHS.HOME)
    }
  }, [isAuthenticated, navigate, dispatch, pathname, search])

  useEffect(() => {
    if (isDeferredPath(previousPathname)) dispatch({ type: 'CLEAR_DEEPLINK_CACHE' })
  }, [previousPathname, dispatch])

  if (!isAuthenticated) {
    return <></>
  }

  return <>{children}</>
}
